import React from 'react';

import ButtonField from './components/ButtonField';
import ServiceAdherenceField from './components/ServiceAdherenceField';
import TextField from './components/TextField';
import HeaderField from './components/HeaderField';

/* eslint-disable react/display-name */
const FIELD_COMPONENT_MAP = {
  TextField: (row, index) => <TextField field={row.field} value={row.value} index={index} />,
  HeaderField: (row, index, onCheck) => <HeaderField onCheck={onCheck} row={row} index={index} />,
  ButtonField: (row, index) => (
    <ButtonField
      field={row.field}
      index={index}
      onPress={row.onPress}
      style={row.style}
      textstyle={row.textstyle}
    >
      {row.children}
    </ButtonField>
  ),
  ServiceAdherenceField: (row, index) => (
    <ServiceAdherenceField
      field={row.field}
      value={row.value}
      account={row.account}
      service={row.service}
      formId={row.formId}
      index={index}
    />
  )
};
/* eslint-enable react/display-name */

export default function FieldRenderer({ row, index, onCheck }) {
  const fieldConstructor = FIELD_COMPONENT_MAP[row.fieldRenderer];

  if (!fieldConstructor) return row.fieldRenderer;

  return fieldConstructor(row, index, onCheck);
}
